module.exports = __webpack_public_path__ + "img/2.1ac0a9a3.png";